<template>
	<div>
		<form-sidebar>
			<v-form method="post" @submit.prevent="submitForm">
				<v-layout
					row wrap
					v-for="(value, key, index) in languages"
					:key="index"
				>
					<v-flex xs1 text-xs-left>
						<v-subheader class="pa-0">{{key}}</v-subheader>
					</v-flex>
					<v-flex xs11>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Nombre"
							v-model="value.name"
						>
						</v-text-field>
					</v-flex>
				</v-layout>
				<v-layout row wrap>
					<v-flex xs12>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Posición"
							v-model="$v.model.position.$model"
							:error="$v.model.position.$error"
						>
						</v-text-field>
					</v-flex>
				</v-layout>
				<v-layout wrap align-center px-2>
					<v-text-field
						solo
						class="body-1 mr-2"
						hide-details
						readonly
						v-model="$v.model.pathIcon.$model"
						:error="$v.model.pathIcon.$error"
					>
					</v-text-field>
					<upload-image 
						label-ref="btn-up"
						label-for="icon"
						input-id="icon"
						@send-image="sendImage"
					/>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						:is-loading ="disabled"
						:on-run-service="loading"
						@cancel-button-clicked="closeModal"
						@accept-button-clicked="submitForm"
					/>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>
import uploadImage from '@/components/shared/upload-image';
import { required, numeric } from 'vuelidate/lib/validators';

function closeModal() {
	this.$emit('close-modal');
}

function created() {
	const languagesKeys = Object.keys(this.languages);
	languagesKeys.forEach((key) => {
		if (this.rows.configLanguages) {
			if (this.rows.configLanguages.languages) {
				this.languages[key].name = this.rows.configLanguages.languages[key].name;
			} else {
				this.languages[key].name = '';
			}
		} else {
			this.languages[key].name = '';
		}
	});
	this.model.position = this.rows.configLanguages ? this.rows.configLanguages.position : '';
	this.model.pathIcon = this.rows.configLanguages ? this.rows.configLanguages.pathIcon :
		this.rows.pathIcon;
}

function sendImage({ urlImage }) {
	this.model.pathIcon = urlImage;
}

async function submitForm() {
	const body = {
		id: this.id,
		languages: this.languages,
		position: this.model.position,
		pathIcon: this.model.pathIcon,
	};
	const headers = {
		Accept: `${process.env.ACCEPT_SERVICE_V2}`,
	};
	this.loading = true;
	try {
		await this.$http.post(`project/${this.codeProject}/company/${this.codeCompany}/resources`,
			body, { headers });
		this.showNotification('Se configuro correctamente.');
		this.closeModal();
	} catch (err) {
		this.showError();
	} finally {
		this.loading = false;
	}
}

function disabled() {
	const languagesKeys = Object.keys(this.languages);
	return !languagesKeys.some(key => this.languages[key].name.trim() && !this.$v.$invalid) ||
		this.loading;
}

function validations() {
	const validation = {
		model: {
			position: {
				required,
				numeric,
			},
			pathIcon: {
				required,
			},
		},
	};
	return validation;
}

function data() {
	return {
		allowedFiles: ['jpg', 'jpeg', 'png', 'svg'],
		isLoadingImage: false,
		loading: false,
		model: {
			position: '',
			pathIcon: '',
		},
	};
}

export default {
	name: 'role-access-configuration',
	data,
	created,
	computed: {
		disabled,
	},
	components: {
		uploadImage,
	},
	methods: {
		closeModal,
		submitForm,
		sendImage,
	},
	props: {
		codeCompany: {
			type: String,
		},
		codeProject: {
			type: String,
		},
		id: {
			type: Number,
		},
		rows: {
			type: Object,
		},
	},
	validations,
};
</script>





// WEBPACK FOOTER //
// src/components/roles/role-access-configuration.vue